<template>
<div>
	<div class="container">
		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<router-link :to="{ name: 'PCReDive'}" tag="li" class="breadcrumb-item">
				<a href="#">首頁</a>
				</router-link>
				<router-link :to="{ name: 'Other'}" tag="li" class="breadcrumb-item">
				<a href="#">其他資訊</a>
				</router-link>
				<li class="breadcrumb-item">
					{{$t('Donors')}}
				</li>
			</ol>
		</nav>
		<div class="item-box">
			<h3 class="item-title">
			{{$t('DonateCap')}}
			</h3>
			<table class="chara-table mb-3">
				<tr>
					<th colspan="3">{{$t('Donors')}}</th>
				</tr>
				<tr>
					<th>{{$t('DonateDate')}}</th>
					<th>{{$t('DonateName')}}</th>
					<th>{{$t('DonateSay')}}</th>
				</tr>
				<tr v-for="item in donateList">
					<td width="10%">{{item.time}}</td>
					<td width="15%">{{item.donator}}</td>
					<td class="text-left pl-3">{{item.value}}</td>
				</tr>
			</table>
		</div>
	</div>
</div>
</template>
<script>
import axios from 'axios'
export default {
	name: 'Donors',
	data() {
		return {
			donateList: []
		}
	},
	metaInfo: {
		// if no subcomponents specify a metaInfo.title, this title will be used
		title: '贊助名單',
		// all titles will be injected into this template
		titleTemplate: '%s | 蘭德索爾圖書館 公主連結 Wiki',
		meta: [
			{ name: 'description', content: '本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。' }
		]
	},
	methods: {
		getDonateList: function(value) {
			var self = this;
			axios.get('/static/data/donate.json')
				.then(function(response) {
					self.donateList = response.data;
				});
		},
	},
	created: function() {
		this.getDonateList();
	},
	computed: {
	},
	mounted: function() {
	}
}
</script>
<style scoped>
</style>